import { countBlobParts } from '@/shared/lib/blob-utils';

import { CHUNK_PART_SIZE } from '../config/audio-recording.config';

export function createChunkStampAllocator() {
    let nextFree = 0;

    return (blobSize: number): number => {
        const stamp = Math.max(Date.now(), nextFree);

        // chunk() spends one stamp per websocket part, so a blob reserves its whole run — else the
        // next blob, or the flush blob emitted in the same millisecond, takes a key the
        // unconditional PutItem overwrites without complaint.
        nextFree = stamp + countBlobParts(blobSize, CHUNK_PART_SIZE);

        return stamp;
    };
}
